import React from "react";
import { useForm } from "react-hook-form";
import welcomImage from "../Assets/welcome.png";
import { Button } from "../Components/Basic";
import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <>
      <div className="flex flex-col items-center mt-20 ">
        {/* checkbox SVG heroicons*/}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-16 w-16 text-green-500 flex-1 mb-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </svg>
        <div className="bg-green-500 h-20 rounded flex px-10 flex-col justify-center">
          <p className=" text-3xl text-center  text-white">
            We've Recevied Your Information
          </p>
        </div>
        <p className="mt-10">
          Our team will be in touch with you shortly to discuss your divorce.
        </p>
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "https://www.familylawassist.com.au";
          }}
          fontSize="lg"
          className="mt-10 w-11/12 md:w-full md:max-w-xs mx-3 md:mx-0 p-4 focus:outline-none bg-nativeOrange-200 hover:bg-yellow-500  hover:border-yellow-500"
        >
          Okay
        </Button>
      </div>
    </>
  );
}
